const Index = () => (
  <div className="flex flex-col items-center justify-center min-h-[calc(100vh-3.5rem)] w-full px-6 text-center">
    <h1 className="text-3xl md:text-5xl font-semibold tracking-tight">FanzUnlimited</h1>
    <p className="mt-4 text-sm md:text-base text-muted-foreground max-w-xl">
      Rebuilding the FanzUnlimited experience with React + Supabase for WordPress-like flexibility and future scalability.
    </p>
  </div>
);

export default Index;